module.exports = __webpack_public_path__ + "img/arrow.c9fd5c7f.svg";